import axios from 'axios';
import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (savedUser && token) {
      verifyUser()
        .then((verifiedUser) => {
          setUser(verifiedUser);
        })
        .catch((err) => {
          console.error(err);
          setUser(null);
          localStorage.removeItem('user');
          localStorage.removeItem('token');
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  const login = async (userData) => {
    try {
      const response = await axios.post('https://api.osgenius.com.br/api/v1/pessoa', {
        _idSistema: "osgenius",
        email: userData.username,
        password: userData.password
      });
      const user = { ...response.data, role: "admin" };
      console.log('Login bem-sucedido:', user);
      setUser(user);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', user.token);
      return user;
    } catch (err) {
      console.error('Erro ao fazer login:', err);
      throw new Error('Falha ao autenticar usuário');
    }
  };

  const verifyUser = async (urlToken = "") => {
    let token = localStorage.getItem('token');

    if (urlToken !== "") {
      token = urlToken;
      localStorage.setItem('token', token);
    }

    if (!token) {
      setUser(null);
      localStorage.removeItem('user');
      throw new Error('Usuário não autenticado');
    }

    return axios.post('https://api.osgenius.com.br/api/v1/pessoa/validar', 
      { token: token }, 
      { headers: { 'Authorization': `Bearer ${token}` } }
    )
      .then(res => {
        const user = { ...res.data, role: "admin" };
        setUser(user);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('token', user.token);
        return user;
      })
      .catch(err => {
        setUser(null);
        localStorage.removeItem('user');
        console.error('Erro ao verificar usuário:', err);
        throw new Error('Falha ao verificar usuário');
      });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  const value = {
    user,
    login,
    logout,
    isLoading,
    verifyUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
